import { OrderVolumeCommodityGroupWidget } from './OrderVolumeCommodityGroupWidget';

export const GeneralOrderVolumeCommodityGroupWidget = () => {
  const cube = 'CommodityGroupRoot';

  return (
    <OrderVolumeCommodityGroupWidget
      config={{
        cube,
        filters: [],
      }}
    />
  );
};
